import { useState, useEffect } from 'react';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <>
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-lg' : 'bg-transparent'
      }`}>
        <div className="max-w-7xl mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            {/* Logo */}
            <div className="flex items-center gap-3">
              <div className={`w-12 h-12 rounded-lg flex items-center justify-center ${
                isScrolled ? 'bg-[#0066FF]' : 'bg-white'
              }`}>
                <i className={`ri-car-washing-line text-2xl ${
                  isScrolled ? 'text-white' : 'text-[#0066FF]'
                }`}></i>
              </div>
              <span className={`text-2xl font-black ${
                isScrolled ? 'text-gray-900' : 'text-white'
              }`}>
                DetailerX
              </span>
            </div>

            {/* Desktop Navigation */}
            <div className="hidden md:flex items-center gap-8">
              <a href="#guarantee" className={`font-semibold hover:text-[#FF6B4A] transition-colors cursor-pointer ${
                isScrolled ? 'text-gray-700' : 'text-white'
              }`}>
                Our Guarantee
              </a>
              <a href="#services" className={`font-semibold hover:text-[#FF6B4A] transition-colors cursor-pointer ${
                isScrolled ? 'text-gray-700' : 'text-white'
              }`}>
                Services
              </a>
              <a href="#process" className={`font-semibold hover:text-[#FF6B4A] transition-colors cursor-pointer ${
                isScrolled ? 'text-gray-700' : 'text-white'
              }`}>
                Process
              </a>
              <a href="#faq" className={`font-semibold hover:text-[#FF6B4A] transition-colors cursor-pointer ${
                isScrolled ? 'text-gray-700' : 'text-white'
              }`}>
                FAQ
              </a>
              <a
                href="https://calendly.com/detailerx-agencys/detailerx-discovery-call"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-[#FF6B4A] text-white px-6 py-3 rounded-lg font-bold hover:bg-[#ff5a39] transition-all whitespace-nowrap cursor-pointer"
              >
                Book Strategy Call
              </a>
            </div>

            {/* Mobile Menu Button */}
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className={`md:hidden w-10 h-10 flex items-center justify-center cursor-pointer ${
                isScrolled ? 'text-gray-900' : 'text-white'
              }`}
            >
              <i className={`text-2xl ${isMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="md:hidden bg-white border-t border-gray-200">
            <div className="px-6 py-4 space-y-4">
              <a href="#guarantee" className="block text-gray-700 font-semibold hover:text-[#FF6B4A] transition-colors cursor-pointer">
                Our Guarantee
              </a>
              <a href="#services" className="block text-gray-700 font-semibold hover:text-[#FF6B4A] transition-colors cursor-pointer">
                Services
              </a>
              <a href="#process" className="block text-gray-700 font-semibold hover:text-[#FF6B4A] transition-colors cursor-pointer">
                Process
              </a>
              <a href="#faq" className="block text-gray-700 font-semibold hover:text-[#FF6B4A] transition-colors cursor-pointer">
                FAQ
              </a>
              <a
                href="https://calendly.com/detailerx-agencys/detailerx-discovery-call"
                target="_blank"
                rel="noopener noreferrer"
                className="block bg-[#FF6B4A] text-white px-6 py-3 rounded-lg font-bold hover:bg-[#ff5a39] transition-all text-center whitespace-nowrap cursor-pointer"
              >
                Book Strategy Call
              </a>
            </div>
          </div>
        )}
      </nav>
    </>
  );
}
